import { Header } from "@deere/fuel-react/Header";
import { CustomHeaderAction } from "../layout/CustomHeaderAction";

function MainHeader() {
  return (
    <Header applicationName={"EDI Self-Service Portal"}>
      <CustomHeaderAction />
    </Header>
  );
}
export default MainHeader;
